import React from 'react';
import T from 'prop-types';

import NewFeatureRequestButton from '../../../../components/NewFeatureRequestButton';

const MoreReporsCard = ({ isLoggedUser }) => (
  <div className="report-card report-card-more mb-md">
    <div className="report-image-box-disabled" />
    <div className="report-text-more">
      <div className="report-card-more-heading">
        150+ <br /> More Reports
      </div>
      <p className="report-card-more-description">
        Research and insights on top companies, including correlations between mobile data and&nbsp;
        company KPIs, industry analysis, earnings previews, and more.
      </p>
      {isLoggedUser && (
        <NewFeatureRequestButton
          featureName="Research Library"
          buttonText="Request Access"
          buttonClassName="hms-btn hms-btn--sm hms-btn--primary request-btn"
          showErrorInTooltip
        />
      )}
    </div>
  </div>
);

MoreReporsCard.propTypes = {
  isLoggedUser: T.bool,
};

export default MoreReporsCard;
